<template>
    <router-view />
</template>

<script>
    export default {
        name: 'TriggeredReferral',
    }
</script>

<style scoped>

</style>